export default function parse(str, ...args) {
  let i = 0;

  return str.replace(/%s/g, function () {
    return args[i++];
  });
}
